/**
 * np-product-grid-pager.js — "You may also like" on the product page
 *
 * Recommendations:
 *   [data-np-recommendations-url] (product without related_collection) is replaced
 *   with Shopify's automatic recommendations, rendered by the same section.
 *
 * Paging:
 *   .product-grid--related shows 8 cards at 4 columns, 6 otherwise.
 *   When there are more, numbered dots (.np-pagination) switch pages with the
 *   same left/right slide as page navigation.
 *   The grid keeps the height of a full page, so a short last page leaves blank space.
 *
 * Collection pagination:
 *   The numbered dot links load the next page with fetch and slide only the grid,
 *   instead of navigating the whole page. The URL (?page=N) is kept in history.
 *
 * The slide itself is npSlideSwap() in np-slide-swap.js.
 */

(function () {
  function perPage(grid) {
    var cols = getComputedStyle(grid).gridTemplateColumns.split(' ').length;
    return cols >= 4 ? 8 : 6;
  }

  function initPager(grid) {
    if (grid.dataset.npPager) return;
    grid.dataset.npPager = '1';

    var cards = Array.prototype.slice.call(grid.querySelectorAll(':scope > .product-card'));
    if (!cards.length) return;

    var viewport = document.createElement('div');
    viewport.className = 'np-slide-viewport';
    grid.parentNode.insertBefore(viewport, grid);
    viewport.appendChild(grid);

    var nav = document.createElement('nav');
    nav.className = 'np-pagination np-pagination--related';
    nav.setAttribute('aria-label', 'Page navigation');
    viewport.insertAdjacentElement('afterend', nav);

    grid.classList.add('product-grid--paged');

    var size = 0;
    var pages = 1;
    var current = 0;

    function show(page) {
      cards.forEach(function (c, i) {
        c.classList.toggle('is-off-page', Math.floor(i / size) !== page);
      });
    }

    function renderDots() {
      nav.innerHTML = '';
      nav.style.display = pages < 2 ? 'none' : '';
      for (var i = 0; i < pages; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'np-pagination__dot' + (i === current ? ' is-active' : '');
        dot.textContent = i + 1;
        if (i === current) dot.setAttribute('aria-current', 'page');
        dot.dataset.page = i;
        nav.appendChild(dot);
      }
    }

    function markLastRow() {
      if (typeof markLastRowCards === 'function') markLastRowCards(viewport);
    }

    // recalculates page size; keeps the first visible card on screen
    function layout() {
      var newSize = perPage(grid);
      var first = current * (size || newSize);
      size = newSize;
      pages = Math.ceil(cards.length / size);
      current = Math.min(Math.floor(first / size), pages - 1);

      // fixed height = a full first page
      grid.style.minHeight = '';
      if (pages > 1) {
        show(0);
        grid.style.minHeight = grid.offsetHeight + 'px';
      }
      show(current);
      renderDots();
      markLastRow();
    }

    function goTo(page) {
      if (page === current || page < 0 || page >= pages) return;
      var forward = page > current;
      npSlideSwap(viewport, grid, forward, function () {
        current = page;
        show(current);
        renderDots();
        markLastRow();
      });
    }

    nav.addEventListener('click', function (e) {
      var dot = e.target.closest('.np-pagination__dot');
      if (dot) goTo(parseInt(dot.dataset.page, 10));
    });

    var timer;
    window.addEventListener('resize', function () {
      clearTimeout(timer);
      timer = setTimeout(layout, 150);
    });

    layout();
  }

  function initAll(root) {
    (root || document).querySelectorAll('.product-grid--related').forEach(initPager);
  }

  function loadRecommendations(el) {
    var url = el.getAttribute('data-np-recommendations-url');
    el.removeAttribute('data-np-recommendations-url');
    fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var fresh = doc.querySelector('.np-product-grid');
        if (!fresh || !fresh.querySelector('.product-card')) return;
        el.innerHTML = fresh.innerHTML;
        if (typeof initProductCards === 'function') initProductCards(el);
        initAll(el);
      })
      .catch(function () {});
  }

  // ─── Collection pagination ───
  var NAV_SEL = '.np-product-grid .np-pagination:not(.np-pagination--related)';

  function pageOf(url) {
    return parseInt(new URL(url, location.href).searchParams.get('page'), 10) || 1;
  }

  function collectionViewport(grid) {
    var viewport = grid.parentNode;
    if (viewport.classList.contains('np-slide-viewport')) return viewport;
    viewport = document.createElement('div');
    viewport.className = 'np-slide-viewport';
    grid.parentNode.insertBefore(viewport, grid);
    viewport.appendChild(grid);
    return viewport;
  }

  var shownUrl = location.href;

  function loadPage(url, push) {
    var grid = document.querySelector('.np-product-grid .product-grid:not(.product-grid--related)');
    var nav = document.querySelector(NAV_SEL);
    if (!grid || !nav) return location.assign(url);

    fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var freshGrid = doc.querySelector('.np-product-grid .product-grid');
        var freshNav = doc.querySelector(NAV_SEL);
        if (!freshGrid) return location.assign(url);

        var viewport = collectionViewport(grid);
        var forward = pageOf(url) > pageOf(shownUrl);
        // the dots stay where they were on screen (they are under the finger),
        // even when the new page is shorter or taller
        var navTop = nav.getBoundingClientRect().top;
        var started = npSlideSwap(viewport, grid, forward, function () {
          grid.className = freshGrid.className;
          grid.innerHTML = freshGrid.innerHTML;
          if (freshNav) nav.replaceWith(freshNav);
          if (typeof initProductCards === 'function') initProductCards(grid);
          if (typeof markLastRowCards === 'function') markLastRowCards(viewport);
          window.dispatchEvent(new Event('resize')); // grid spacer below the section
          var newNav = freshNav || nav;
          window.scrollBy({ top: newNav.getBoundingClientRect().top - navTop, behavior: 'instant' });
        });
        if (!started) return;

        shownUrl = url;
        if (push) history.pushState({ npPage: true }, '', url);
      })
      .catch(function () { location.assign(url); });
  }

  document.addEventListener('click', function (e) {
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var link = e.target.closest && e.target.closest(NAV_SEL + ' a[href]');
    if (!link || !window.npSlideSwap) return;
    e.preventDefault();
    // the page slide script in theme.liquid marks pagination clicks for the next page load
    try { sessionStorage.removeItem('np-vt-force-back'); } catch (err) {}
    if (pageOf(link.href) !== pageOf(shownUrl)) loadPage(link.href, true);
  });

  window.addEventListener('popstate', function () {
    if (pageOf(location.href) !== pageOf(shownUrl) && document.querySelector(NAV_SEL)) loadPage(location.href, false);
  });

  function init(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-np-recommendations-url]').forEach(loadRecommendations);
    initAll(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  }
})();
